import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileUploader } from "./FileUploader";
import { useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
const AddAttachment = ({ onFileUpload, isFileUploading, label, helperText, }) => {
    const [loading, setLoading] = useState(false);
    const handleFileUpload = async (event) => {
        setLoading(true);
        if (isFileUploading) {
            isFileUploading(true);
        }
        try {
            await FileUploader.handleUpload(event, async (file, base64) => {
                if (onFileUpload) {
                    onFileUpload(file, base64);
                }
            });
        }
        finally {
            setLoading(false);
            if (isFileUploading) {
                isFileUploading(false);
            }
        }
    };
    return (_jsx(Grid, { item: true, xs: 12, children: _jsxs("div", { className: "add-attachments", children: [_jsx("label", { htmlFor: "File", children: label ?? "Add Attachments".toUpperCase() }), _jsx("div", { className: "upload-container", children: _jsxs("div", { className: "upload-wrap", children: [_jsx("input", { id: "File", name: "File", type: "file", onChange: (event) => {
                                    handleFileUpload(event);
                                }, className: "form-control file-upload-input" }), _jsx("div", { className: "drag-text", children: loading ? (_jsx(CircularProgress, { color: "inherit" })) : (_jsxs("div", { children: [_jsx("h3", { children: "Drag & drop" }), _jsx("p", { children: "or browse your files" }), helperText && _jsxs("p", { children: ["(", helperText, ")"] })] })) })] }) })] }) }));
};
export default AddAttachment;
